import axios from 'axios';

import {authHeader} from '../helpers/auth.helper';

export const FETCH_EMPRESA = 'FETCH_EMPRESA';
export const FETCH_EMPRESA_SUCCESS = 'FETCH_EMPRESA_SUCCESS';
export const FETCH_EMPRESA_ERROR = 'FETCH_EMPRESA_ERROR';

export const FETCH_EMPRESAS = 'FETCH_EMPRESAS';
export const FETCH_EMPRESAS_SUCCESS = 'FETCH_EMPRESAS_SUCCESS';
export const FETCH_EMPRESAS_ERROR = 'FETCH_EMPRESAS_ERROR';

export const DELETE_EMPRESA_SUCCESS = 'DELETE_USUARIO_SUCCESS';
export const DELETE_EMPRESA_FAILURE = 'DELETE_USUARIO_FAILURE';

export const CREATE_EMPRESA_SUCCESS = 'CREATE_USUARIO_SUCCESS';
export const CREATE_EMPRESA_FAILURE = 'CREATE_USUARIO_FAILURE';

export const UPDATE_EMPRESA_SUCCESS = 'UPDATE_USUARIO_SUCCESS';
export const UPDATE_EMPRESA_FAILURE = 'UPDATE_USUARIO_FAILURE';

const ROOT_URL = 'https://api.monitor-backup.suprasys.com.br';
//const ROOT_URL = 'http://168.138.128.21:8891';
//const ROOT_URL = 'http://localhost:8891';

export function fetchEmpresaById(id) {
    return (dispatch) => {
        dispatch(fetchEmpresaLoading());

        let config = {
            headers: authHeader()
        };

        axios.get(`${ROOT_URL}/empresas/${id}`, config)
            .then(response => dispatch(fetchEmpresaSuccess(response)))
            .catch(error => dispatch(fetchEmpresaError(error)));
    }
}

export function fetchEmpresaLoading() {
    return {
        type: FETCH_EMPRESA
    }
}

export function fetchEmpresaSuccess(response) {
    return {
        type: FETCH_EMPRESA_SUCCESS,
        payload: response.data
    };
}

export function fetchEmpresaError(error) {
    return {
        type: FETCH_EMPRESA_ERROR,
        payload: error
    }
}

export function fetchEmpresas() {
    return (dispatch) => {
        dispatch(fetchEmpresasLoading());

        let config = {
            headers: authHeader()
        };

        axios.get(`${ROOT_URL}/empresas`, config)
            .then(response => dispatch(fetchEmpresasSuccess(response)))
            .catch(error => dispatch(fetchEmpresasError(error)));
    }
}

export function fetchEmpresasLoading() {
    return {
        type: FETCH_EMPRESAS
    }
}

export function fetchEmpresasSuccess(response) {
    return {
        type: FETCH_EMPRESAS_SUCCESS,
        payload: response.data
    };
}

export function fetchEmpresasError(error) {
    return {
        type: FETCH_EMPRESAS_ERROR,
        payload: error
    }
}

export function deleteEmpresa(cnpj) {
    return (dispatch) => {
        let config = {
            headers: authHeader()
        };

        axios.delete(`${ROOT_URL}/empresas/cnpj/${cnpj}`, config)
            .then(response => {
                dispatch(deleteEmpresaSuccess(response));
                dispatch(fetchEmpresas());
            })
            .catch(error => dispatch(deleteEmpresaFailure(error)));
    }
}

export function deleteEmpresaSuccess(response) {
    return {
        type: DELETE_EMPRESA_SUCCESS,
        payload: response.data
    };
}

export function deleteEmpresaFailure(error) {
    return {
        type: DELETE_EMPRESA_FAILURE,
        payload: error
    }
}

export function createEmpresa(empresa) {
    let payload = empresa;

    return (dispatch) => {
        let config = {
            headers: authHeader()
        };

        axios.post(`${ROOT_URL}/empresas`, payload, config)
            .then(response => {
                dispatch(createEmpresaSuccess(response));
                dispatch(fetchEmpresas());
            })
            .catch(error => dispatch(createEmpresaFailure(error)));
    }
}

export function createEmpresaSuccess(response) {
    return {
        type: CREATE_EMPRESA_SUCCESS,
        payload: response.data
    }
}

export function createEmpresaFailure(error) {
    return {
        type: CREATE_EMPRESA_FAILURE,
        payload: error
    }
}

export function updateEmpresa(empresa) {
    let payload = empresa;

    return (dispatch) => {
        let config = {
            headers: authHeader()
        };

        axios.put(`${ROOT_URL}/empresas/${empresa.id}`, payload, config)
            .then(response => {
                dispatch(updateEmpresaSuccess(response));
                dispatch(fetchEmpresas());
            })
            .catch(error => dispatch(updateEmpresaFailure(error)));
    }
}

export function updateEmpresaSuccess(response) {
    return {
        type: UPDATE_EMPRESA_SUCCESS,
        payload: response.data
    }
}

export function updateEmpresaFailure(error) {
    return {
        type: UPDATE_EMPRESA_FAILURE,
        payload: error
    }
}



// WEBPACK FOOTER //
// src/actions/empresa.js